import type { Filters } from '@ipfabric/utils';

export const joinFilters = (
  operator: 'and' | 'or',
  filters: Filters[],
): Filters => {
  if (filters.length === 0) {
    return {};
  }
  return filters.length > 1
    ? {
        [operator]: filters,
      }
    : // Fixed noUncheckedIndexedAccess NIM-19408
      filters[0]!;
};
